import { t } from '@lingui/macro';
import { i18n } from '../../utils/setupTranslations';
import { NewPackFormVisibleFieldKeys, NewPackFormKeys } from './NewPack.types';

export const newPackFieldOrderPart1: Array<NewPackFormVisibleFieldKeys> = [
    NewPackFormKeys.Name,
    NewPackFormKeys.Description,
];

export const newPackFieldOrderPart2: Array<NewPackFormVisibleFieldKeys> = [
    NewPackFormKeys.LabelName,
];

export const newPackFieldOrderPart3: Array<NewPackFormVisibleFieldKeys> = [
    NewPackFormKeys.Genre,
    NewPackFormKeys.Subgenre,
];

export const newPackFieldOrderPart4: Array<NewPackFormVisibleFieldKeys> = [
    NewPackFormKeys.Exclusivity,
    NewPackFormKeys.Lexicon,
];

export const newPackFieldOrderPart5: Array<NewPackFormVisibleFieldKeys> = [
    NewPackFormKeys.DemoUpload,
    NewPackFormKeys.ArtworkUpload,
    NewPackFormKeys.ZipUpload,
    NewPackFormKeys.CsvUpload,
];

export const newPackFieldTitles: {
    [key in NewPackFormVisibleFieldKeys]: string;
} = {
    [NewPackFormKeys.Name]: i18n._(t`Pack Name`),
    [NewPackFormKeys.Description]: i18n._(t`Pack Description`),
    [NewPackFormKeys.LabelName]: i18n._(t`Label`),
    [NewPackFormKeys.Genre]: i18n._(t`Pack Genre`),
    [NewPackFormKeys.Subgenre]: i18n._(t`Pack Subgenre`),
    [NewPackFormKeys.Exclusivity]: i18n._(t`Exclusivity`),
    [NewPackFormKeys.Lexicon]: i18n._(t`Metadata categories`),
    [NewPackFormKeys.DemoUpload]: i18n._(t`Pack Demo`),
    [NewPackFormKeys.ArtworkUpload]: i18n._(t`Pack Artwork`),
    [NewPackFormKeys.ZipUpload]: i18n._(t`Samples ZIP`),
    [NewPackFormKeys.CsvUpload]: i18n._(t`Metadata`),
};

export const newPackFieldDescriptions: Partial<Record<
    NewPackFormVisibleFieldKeys,
    string
>> = {
    [NewPackFormKeys.Name]: i18n._(
        t`Please let us know the exact name of the sample pack as you want it to be displayed on the site.`,
    ),
    [NewPackFormKeys.Description]: i18n._(
        t`Do not include any reference to MIDI or preset files.`,
    ),
    [NewPackFormKeys.DemoUpload]: i18n._(
        t`Audio demo highlighting the best sounds in your pack. 30 seconds or longer.`,
    ),
    [NewPackFormKeys.ArtworkUpload]: i18n._(
        t`The cover to best represent your pack`,
    ),
    [NewPackFormKeys.ZipUpload]: i18n._(
        t`The file to be downloaded by our users by clicking on "Get pack".`,
    ),
    [NewPackFormKeys.CsvUpload]: i18n._(
        t`Upload a CSV file containing the samples metadata.`,
    ),
};

export const newPackFieldPlaceholder: Partial<Record<
    NewPackFormVisibleFieldKeys,
    string
>> = {
    [NewPackFormKeys.Name]: i18n._(t`Enter the pack name`),
    [NewPackFormKeys.Description]: i18n._(t`Enter the pack description`),
    [NewPackFormKeys.LabelName]: i18n._(t`Select a label`),
    [NewPackFormKeys.Genre]: i18n._(t`Choose...`),
    [NewPackFormKeys.Subgenre]: i18n._(t`Choose...`),
};

export const UPLOAD_KEYS = [
    NewPackFormKeys.CsvUpload,
    NewPackFormKeys.DemoUpload,
    NewPackFormKeys.ArtworkUpload,
    NewPackFormKeys.ZipUpload,
] as const;

export type UploadKeys = typeof UPLOAD_KEYS;
export type UploadKey = UploadKeys[number];
export type UploadStatus = 'pending' | 'loading' | 'failed' | 'complete';

export const UPLOAD_ENPOINTS: Record<UploadKey, string> = {
    [NewPackFormKeys.CsvUpload]: 'v1/packs/csv/upload',
    [NewPackFormKeys.DemoUpload]: 'v1/packs/demo/upload',
    [NewPackFormKeys.ArtworkUpload]: 'v1/packs/artwork/upload',
    [NewPackFormKeys.ZipUpload]: 'v1/packs/archive/upload',
};

export type FieldProgress = { uploaded: number; total: number };

export type FieldProgressType = {
    csvUpload: FieldProgress;
    demoUpload: FieldProgress;
    artworkUpload: FieldProgress;
    zipUpload: FieldProgress;
};

export const defaultFieldProgress: FieldProgressType = {
    csvUpload: { uploaded: 0, total: 0 },
    demoUpload: { uploaded: 0, total: 0 },
    artworkUpload: { uploaded: 0, total: 0 },
    zipUpload: { uploaded: 0, total: 0 },
};
